import { useRef, useEffect, useCallback } from 'react';

export const useGameLoop = (callback, isRunning) => {
    const requestRef = useRef();
    const previousTimeRef = useRef();
    const lastTimeRef = useRef(0);

    const animate = useCallback((now) => {
        if (!isRunning) return; // Stop if not running

        // Calculate delta time
        const dt = (now - lastTimeRef.current) / 1000;
        lastTimeRef.current = now;

        callback(now, dt);

        requestRef.current = requestAnimationFrame(animate);
    }, [callback, isRunning]);

    useEffect(() => {
        if (isRunning) {
            lastTimeRef.current = performance.now();
            requestRef.current = requestAnimationFrame(animate);
        } else {
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        }

        return () => {
            if (requestRef.current) {
                cancelAnimationFrame(requestRef.current);
            }
        };
    }, [isRunning, animate]);
};
